import { combineReducers } from 'redux';
import { toolsReducer } from './features/tools';
import { userReducer } from './features/user';
import { employeesReducer } from './features/employees';
import { linePlannerReducer } from './features/linePlanner';
import { imageReducer } from './features/image';
import { dataReducer } from './features/data';

const rootReducer = combineReducers({
  tools: toolsReducer,
  employees: employeesReducer,
  user: userReducer,
  linePlanner: linePlannerReducer,
  image: imageReducer,
  data: dataReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer